import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { ScheduleDetail } from '../../../models/schedules/schedule.model';
import useHttps from '../../useHttps';

export type ScheduleAction = 'pause' | 'cancel' | 'run-now';

// One schedule with its runs and audit trail, plus the admin actions. Only
// the user can resume a paused schedule (with their PIN), so there's no resume.
const useScheduleDetail = (scheduleId?: string) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [schedule, setSchedule] = useState<ScheduleDetail | null>(null);

  useEffect(() => {
    if (!scheduleId) return;
    request(
      { url: `api/v1/admin/schedules/${scheduleId}`, method: 'get' },
      ({ data }: SuccessHttpResponse<ScheduleDetail>) => setSchedule(data),
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'Failed to load schedule')
    );
    // eslint-disable-next-line
  }, [scheduleId]);

  const act = (action: ScheduleAction, onDone?: () => void) => {
    if (!scheduleId) return;
    request(
      { url: `api/v1/admin/schedules/${scheduleId}/${action}`, method: 'post' },
      ({ data }: SuccessHttpResponse<ScheduleDetail>) => {
        setSchedule(data);
        toast.success('Done');
        onDone?.();
      },
      setSaving,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'That action failed')
    );
  };

  return { schedule, loading, saving, act };
};

export default useScheduleDetail;
